// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getProductState, getProductStateByPath } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import cloneDeep from "lodash/cloneDeep";

export function getComputedVariantProduct(
    parentProductState: ReturnType<typeof getProductStateByPath>,
    variantProductState: ReturnType<typeof getProductState>,
) {
    if (!variantProductState.value) {
        return parentProductState;
    }

    if (!parentProductState.value) {
        return parentProductState;
    }

    if (parentProductState.value.id === variantProductState.value.id) {
        return parentProductState;
    }

    const { value: variantProduct } = variantProductState;

    const computedProduct = cloneDeep(parentProductState.value);
    Object.assign(computedProduct, {
        productNumber: variantProduct.productNumber,
        customerProductNumber: variantProduct.customerProductNumber,
        smallImagePath: variantProduct.smallImagePath,
        mediumImagePath: variantProduct.mediumImagePath,
        largeImagePath: variantProduct.largeImagePath,
        imageAltText: variantProduct.imageAltText,
        id: variantProduct.id,
        quoteRequired: variantProduct.quoteRequired,
        productTitle: variantProduct.productTitle,
        images: variantProduct.images,
        trackInventory: variantProduct.trackInventory,
        minimumOrderQty: variantProduct.minimumOrderQty,
        canonicalUrl: variantProduct.canonicalUrl,
        unitOfMeasures: variantProduct.unitOfMeasures,
        isVariantParent: false,
        canAddToWishlist: variantProduct.canAddToWishlist,
        cantBuy: variantProduct.cantBuy,
        allowZeroPricing: variantProduct.allowZeroPricing,
        manufacturerItem: variantProduct.manufacturerItem,
        detail: variantProduct.detail,
        content:
            variantProduct.content && variantProduct.content.htmlContent !== ""
                ? variantProduct.content
                : parentProductState.value.content,
        documents:
            variantProduct.documents && variantProduct.documents.length > 0
                ? variantProduct.documents.concat(parentProductState.value.documents || [])
                : parentProductState.value.documents,
        specifications:
            variantProduct.specifications && variantProduct.specifications.length > 0
                ? variantProduct.specifications
                : parentProductState.value.specifications,
        attributeTypes:
            variantProduct.attributeTypes && variantProduct.attributeTypes.length > 0
                ? variantProduct.attributeTypes
                : parentProductState.value.attributeTypes,
        badges:
            variantProduct.badges && variantProduct.badges.length > 0
                ? variantProduct.badges
                : parentProductState.value.badges,
                
        // XNG-Change: clone proptries
        properties: variantProduct.properties
    });

    return {
        isLoading: parentProductState.isLoading,
        id: variantProductState.id,
        value: computedProduct,
    };
}
